import { I18N } from '../../../utils/i18n/i18n';

export namespace HybridShareCommunityI18n {
    export function translations() {
        return [
            { en: 'Population in', zhCN: '人口数量' },
            { en: 'Total private dwellings', zhCN: '私人住宅数' },
            { en: 'Land area', zhCN: '土地面积' },
            { en: 'Average Household Size', zhCN: '人均占地面积' },
            { en: 'Average Household Income', zhCN: '人均收入' },
            { en: 'Number of Households', zhCN: '住家数' },
            { en: 'Not in the Labour Force', zhCN: '非劳动力人口' },
            { en: 'Common Languages', zhCN: '语言环境' },
            { en: 'Age Distribution', zhCN: '年龄分布' },
            { en: 'Education Level', zhCN: '教育水平' },
            { en: 'Extremely High Level', zhCN: '极高' },
            { en: 'High Level', zhCN: '高' },
            { en: 'Gender Distribution', zhCN: '性别分布' },
            { en: 'Male', zhCN: '男' },
            { en: 'Female', zhCN: '女' },
            { en: 'Evenly', zhCN: '平均' },
            { en: 'Household income', zhCN: '收入水平' },
            { en: 'Construction Year', zhCN: '建筑年代' },
            { en: 'Household Size', zhCN: '住家大小' },
            { en: 'Most of people', zhCN: '大多数人' },
            { en: 'Never married', zhCN: '未婚' },
            { en: 'Married', zhCN: '已婚' },
            { en: 'Living common law', zhCN: '合法同居' },
            { en: 'Divorced', zhCN: '离婚' },
            { en: 'Widowed', zhCN: '守寡' },
            { en: 'Separated', zhCN: '分居' },
            { en: 'Transportation to Work', zhCN: '上班交通方式' },
            { en: 'Walked', zhCN: '步行' },
            { en: 'Public transit', zhCN: '公共交通' },
            { en: 'Car, truck, van - as a driver', zhCN: '私家车——自己开车' },
            { en: 'Car, truck, van - as a passenger', zhCN: '私家车——作为乘客' },
            { en: 'Bicycle', zhCN: '自行车' },
            { en: 'Other method', zhCN: '其他' },
            { en: 'Employment Type', zhCN: '职业分布' },
            { en: 'Occupied Dwellings', zhCN: '房屋类型' },
            { en: 'Mandarin', zhCN: '普通话' },
            { en: 'Marital Status', zhCN: '婚姻状况' },
        ];
    }
    export function translate(str: string, locale: I18N.EI18nLocale | string) {
        const transs = translations();
        const translation = transs.find((trans: any) => {
            if (str && trans && trans.en) {
                return str.toLowerCase().indexOf(trans.en.toLowerCase()) > -1;
            }
        });
        if (translation !== null && translation !== undefined) {
            return locale === I18N.EI18nLocale.En ? translation!.en : (locale === I18N.EI18nLocale.Zn ? str.replace(translation!.en, translation!.zhCN) : str);
        }
        return str;
    }
    export function googleTransOptimize(str: string) {
        return str.replace('了', '').replace('走路', '步行').replace('走', '步行');
    }
}
